/**
 * [WARNING!]
 * text-… and bg-… are written here explicitly to prevent
 * tailwindcss class purging
 */

import {logger, ObjUtil} from 'yougile-util'

export const primaryColors = {
  'grey-l100': ['text-grey-l100', 'bg-grey-l100'],
  'grey-l80': ['text-grey-l80', 'bg-grey-l80'],
  'grey-l60': ['text-grey-l60', 'bg-grey-l60'],
  'grey-l40': ['text-grey-l40', 'bg-grey-l40'],
  'grey-l20': ['text-grey-l20', 'bg-grey-l20'],
  grey: ['text-grey', 'bg-grey'],
  'grey-d20': ['text-grey-d20', 'bg-grey-d20'],
  'grey-d40': ['text-grey-d40', 'bg-grey-d40'],
  'grey-d60': ['text-grey-d60', 'bg-grey-d60'],
  'grey-d80': ['text-grey-d80', 'bg-grey-d80'],

  'error-l100': ['text-error-l100', 'bg-error-l100'],
  'error-l80': ['text-error-l80', 'bg-error-l80'],
  'error-l60': ['text-error-l60', 'bg-error-l60'],
  'error-l40': ['text-error-l40', 'bg-error-l40'],
  'error-l20': ['text-error-l20', 'bg-error-l20'],
  error: ['text-error', 'bg-error'],
  'error-d20': ['text-error-d20', 'bg-error-d20'],
  'error-d40': ['text-error-d40', 'bg-error-d40'],
  'error-d60': ['text-error-d60', 'bg-error-d60'],
  'error-d80': ['text-error-d80', 'bg-error-d80'],

  'warning-l100': ['text-warning-l100', 'bg-warning-l100'],
  'warning-l80': ['text-warning-l80', 'bg-warning-l80'],
  'warning-l60': ['text-warning-l60', 'bg-warning-l60'],
  'warning-l40': ['text-warning-l40', 'bg-warning-l40'],
  'warning-l20': ['text-warning-l20', 'bg-warning-l20'],
  warning: ['text-warning', 'bg-warning'],
  'warning-d20': ['text-warning-d20', 'bg-warning-d20'],
  'warning-d40': ['text-warning-d40', 'bg-warning-d40'],
  'warning-d60': ['text-warning-d60', 'bg-warning-d60'],
  'warning-d80': ['text-warning-d80', 'bg-warning-d80'],

  'success-l100': ['text-success-l100', 'bg-success-l100'],
  'success-l80': ['text-success-l80', 'bg-success-l80'],
  'success-l60': ['text-success-l60', 'bg-success-l60'],
  'success-l40': ['text-success-l40', 'bg-success-l40'],
  'success-l20': ['text-success-l20', 'bg-success-l20'],
  success: ['text-success', 'bg-success'],
  'success-d20': ['text-success-d20', 'bg-success-d20'],
  'success-d40': ['text-success-d40', 'bg-success-d40'],
  'success-d60': ['text-success-d60', 'bg-success-d60'],
  'success-d80': ['text-success-d80', 'bg-success-d80'],

  'interactive-l100': ['text-interactive-l100', 'bg-interactive-l100'],
  'interactive-l80': ['text-interactive-l80', 'bg-interactive-l80'],
  'interactive-l60': ['text-interactive-l60', 'bg-interactive-l60'],
  'interactive-l40': ['text-interactive-l40', 'bg-interactive-l40'],
  'interactive-l20': ['text-interactive-l20', 'bg-interactive-l20'],
  interactive: ['text-interactive', 'bg-interactive'],
  'interactive-d20': ['text-interactive-d20', 'bg-interactive-d20'],
  'interactive-d40': ['text-interactive-d40', 'bg-interactive-d40'],
  'interactive-d60': ['text-interactive-d60', 'bg-interactive-d60'],
  'interactive-d80': ['text-interactive-d80', 'bg-interactive-d80'],

  'tortoise-l100': ['text-tortoise-l100', 'bg-tortoise-l100'],
  'tortoise-l80': ['text-tortoise-l80', 'bg-tortoise-l80'],
  'tortoise-l60': ['text-tortoise-l60', 'bg-tortoise-l60'],
  'tortoise-l40': ['text-tortoise-l40', 'bg-tortoise-l40'],
  'tortoise-l20': ['text-tortoise-l20', 'bg-tortoise-l20'],
  tortoise: ['text-tortoise', 'bg-tortoise'],
  'tortoise-d20': ['text-tortoise-d20', 'bg-tortoise-d20'],
  'tortoise-d40': ['text-tortoise-d40', 'bg-tortoise-d40'],
  'tortoise-d60': ['text-tortoise-d60', 'bg-tortoise-d60'],
  'tortoise-d80': ['text-tortoise-d80', 'bg-tortoise-d80'],

  'marker-l100': ['text-marker-l100', 'bg-marker-l100'],
  'marker-l80': ['text-marker-l80', 'bg-marker-l80'],
  'marker-l60': ['text-marker-l60', 'bg-marker-l60'],
  'marker-l40': ['text-marker-l40', 'bg-marker-l40'],
  'marker-l20': ['text-marker-l20', 'bg-marker-l20'],
  marker: ['text-marker', 'bg-marker'],
  'marker-d20': ['text-marker-d20', 'bg-marker-d20'],
  'marker-d40': ['text-marker-d40', 'bg-marker-d40'],
  'marker-d60': ['text-marker-d60', 'bg-marker-d60'],
  'marker-d80': ['text-marker-d80', 'bg-marker-d80'],

  'used-l100': ['text-used-l100', 'bg-used-l100'],
  'used-l80': ['text-used-l80', 'bg-used-l80'],
  'used-l60': ['text-used-l60', 'bg-used-l60'],
  'used-l40': ['text-used-l40', 'bg-used-l40'],
  'used-l20': ['text-used-l20', 'bg-used-l20'],
  used: ['text-used', 'bg-used'],
  'used-d20': ['text-used-d20', 'bg-used-d20'],
  'used-d40': ['text-used-d40', 'bg-used-d40'],
  'used-d60': ['text-used-d60', 'bg-used-d60'],
  'used-d80': ['text-used-d80', 'bg-used-d80'],

  'generic-black': ['text-generic-black', 'bg-generic-black'],
  'generic-white': ['text-generic-white', 'bg-generic-white'],
  surface: ['text-surface', 'bg-surface'],

  'action-default': [
    'text-action-default',
    'bg-action-default',
    'border-action-default'
  ],
  'action-hover': [
    'text-action-hover',
    'bg-action-hover',
    'border-action-hover'
  ],
  'action-pressed': [
    'text-action-pressed',
    'bg-action-pressed',
    'border-action-pressed'
  ],
  'action-disabled': [
    'text-action-disabled',
    'bg-action-disabled',
    'border-action-disabled'
  ],
  'icon-primary': [
    'text-icon-primary',
    'bg-icon-primary',
    'border-icon-primary'
  ],
  'icon-secondary': [
    'text-icon-secondary',
    'bg-icon-secondary',
    'border-icon-secondary'
  ],
  'icon-disabled': [
    'text-icon-disabled',
    'bg-icon-disabled',
    'border-icon-disabled'
  ],
  'icon-invert': ['text-icon-invert', 'bg-icon-invert', 'border-icon-invert'],
  'line-base': ['text-line-base', 'bg-line-base', 'border-line-base'],
  'line-hover': ['text-line-hover', 'bg-line-hover', 'border-line-hover'],
  'line-disabled': [
    'text-line-disabled',
    'bg-line-disabled',
    'border-line-disabled'
  ],
  'line-invert': ['text-line-invert', 'bg-line-invert', 'border-line-invert'],
  'background-primary': [
    'text-background-primary',
    'bg-background-primary',
    'border-background-primary'
  ],
  'background-secondary': [
    'text-background-secondary',
    'bg-background-secondary',
    'border-background-secondary'
  ],
  'background-hover': [
    'text-background-hover',
    'bg-background-hover',
    'border-background-hover'
  ],
  'background-active': [
    'text-background-active',
    'bg-background-active',
    'border-background-active'
  ],
  'background-disabled': [
    'text-background-disabled',
    'bg-background-disabled',
    'border-background-disabled'
  ],
  'background-card': [
    'text-background-card',
    'bg-background-card',
    'border-background-card'
  ],
  'background-solid': [
    'text-background-solid',
    'bg-background-solid',
    'border-background-solid'
  ],
  'background-subtask-open': [
    'text-background-subtask-open',
    'bg-background-subtask-open',
    'border-background-subtask-open'
  ],
  'background-sticker-panel': [
    'text-background-sticker-panel',
    'bg-background-sticker-panel',
    'border-background-sticker-panel'
  ],
  'notification-primary': [
    'text-notification-primary',
    'bg-notification-primary',
    'border-notification-primary'
  ],
  'status-success': [
    'text-status-success',
    'bg-status-success',
    'border-status-success'
  ],
  'status-warning': [
    'text-status-warning',
    'bg-status-warning',
    'border-status-warning'
  ],
  'status-error': [
    'text-status-error',
    'bg-status-error',
    'border-status-error'
  ],
  'normal-gray': ['text-normal-gray', 'bg-normal-gray', 'border-normal-gray'],
  'normal-red': ['text-normal-red', 'bg-normal-red', 'border-normal-red'],
  'normal-pink': ['text-normal-pink', 'bg-normal-pink', 'border-normal-pink'],
  'normal-orange': [
    'text-normal-orange',
    'bg-normal-orange',
    'border-normal-orange'
  ],
  'normal-yellow': [
    'text-normal-yellow',
    'bg-normal-yellow',
    'border-normal-yellow'
  ],
  'normal-green': [
    'text-normal-green',
    'bg-normal-green',
    'border-normal-green'
  ],
  'normal-turquoise': [
    'text-normal-turquoise',
    'bg-normal-turquoise',
    'border-normal-turquoise'
  ],
  'normal-blue': ['text-normal-blue', 'bg-normal-blue', 'border-normal-blue'],
  'normal-violet': [
    'text-normal-violet',
    'bg-normal-violet',
    'border-normal-violet'
  ],

  'acid-gray': ['text-acid-gray', 'bg-acid-gray', 'border-acid-gray'],
  'acid-red': ['text-acid-red', 'bg-acid-red', 'border-acid-red'],
  'acid-pink': ['text-acid-pink', 'bg-acid-pink', 'border-acid-pink'],
  'acid-orange': ['text-acid-orange', 'bg-acid-orange', 'border-acid-orange'],
  'acid-yellow': ['text-acid-yellow', 'bg-acid-yellow', 'border-acid-yellow'],
  'acid-green': ['text-acid-green', 'bg-acid-green', 'border-acid-green'],
  'acid-turquoise': [
    'text-acid-turquoise',
    'bg-acid-turquoise',
    'border-acid-turquoise'
  ],
  'acid-blue': ['text-acid-blue', 'bg-acid-blue', 'border-acid-blue'],
  'acid-violet': ['text-acid-violet', 'bg-acid-violet', 'border-acid-violet'],
  'light-gray': ['text-light-gray', 'bg-light-gray', 'border-light-gray'],
  'light-red': ['text-light-red', 'bg-light-red', 'border-light-red'],
  'light-pink': ['text-light-pink', 'bg-light-pink', 'border-light-pink'],
  'light-orange': [
    'text-light-orange',
    'bg-light-orange',
    'border-light-orange'
  ],
  'light-green': ['text-light-green', 'bg-light-green', 'border-light-green'],
  'light-turquoise': [
    'text-light-turquoise',
    'bg-light-turquoise',
    'border-light-turquoise'
  ],
  'light-blue': ['text-light-blue', 'bg-light-blue', 'border-light-blue'],
  'light-violet': [
    'text-light-violet',
    'bg-light-violet',
    'border-light-violet'
  ],
  'opacity-invert-40': [
    'text-opacity-invert-40',
    'bg-opacity-invert-40',
    'border-opacity-invert-40'
  ],
  'opacity-gray-96': [
    'text-opacity-gray-96',
    'bg-opacity-gray-96',
    'border-opacity-gray-96'
  ],
  'opacity-gray-40': [
    'text-opacity-gray-40',
    'bg-opacity-gray-40',
    'border-opacity-gray-40'
  ],
  'panel-text-primary': [
    'text-panel-text-primary',
    'bg-panel-text-primary',
    'border-panel-text-primary'
  ],
  'panel-text-secondary': [
    'text-panel-text-secondary',
    'bg-panel-text-secondary',
    'border-panel-text-secondary'
  ],
  'panel-text-placeholder': [
    'text-panel-text-placeholder',
    'bg-panel-text-placeholder',
    'border-panel-text-placeholder'
  ],
  'panel-icon-primary': [
    'text-panel-icon-primary',
    'bg-panel-icon-primary',
    'border-panel-icon-primary'
  ],
  'panel-icon-secondary': [
    'text-panel-icon-secondary',
    'bg-panel-icon-secondary',
    'border-panel-icon-secondary'
  ],
  'panel-line-base': [
    'text-panel-line-base',
    'bg-panel-line-base',
    'border-panel-line-base'
  ],
  'panel-background-default': [
    'text-panel-background-default',
    'bg-panel-background-default',
    'border-panel-background-default'
  ],
  'panel-background-constant': [
    'text-panel-background-constant',
    'bg-panel-background-constant',
    'border-panel-background-constant'
  ],
  'panel-background-hover': [
    'text-panel-background-hover',
    'bg-panel-background-hover',
    'border-panel-background-hover'
  ],
  'panel-background-active': [
    'text-panel-background-active',
    'bg-panel-background-active',
    'border-panel-background-active'
  ]
} as const

export const customColors = {
  'sticker-01': ['text-sticker-01', 'bg-sticker-01'],
  'sticker-02': ['text-sticker-02', 'bg-sticker-02'],
  'sticker-03': ['text-sticker-03', 'bg-sticker-03'],
  'sticker-04': ['text-sticker-04', 'bg-sticker-04'],
  'sticker-05': ['text-sticker-05', 'bg-sticker-05'],
  'sticker-06': ['text-sticker-06', 'bg-sticker-06'],
  'sticker-07': ['text-sticker-07', 'bg-sticker-07'],
  'sticker-08': ['text-sticker-08', 'bg-sticker-08'],
  'sticker-09': ['text-sticker-09', 'bg-sticker-09'],
  'sticker-10': ['text-sticker-10', 'bg-sticker-10'],
  'sticker-11': ['text-sticker-11', 'bg-sticker-11'],

  'column-01': ['text-column-01', 'bg-column-01'],
  'column-02': ['text-column-02', 'bg-column-02'],
  'column-03': ['text-column-03', 'bg-column-03'],
  'column-04': ['text-column-04', 'bg-column-04'],
  'column-05': ['text-column-05', 'bg-column-05'],
  'column-06': ['text-column-06', 'bg-column-06'],
  'column-07': ['text-column-07', 'bg-column-07'],
  'column-08': ['text-column-08', 'bg-column-08'],
  'column-09': ['text-column-09', 'bg-column-09'],
  'column-10': ['text-column-10', 'bg-column-10'],
  'column-11': ['text-column-11', 'bg-column-11'],
  'column-12': ['text-column-12', 'bg-column-12'],
  'column-13': ['text-column-13', 'bg-column-13'],
  'column-14': ['text-column-14', 'bg-column-14'],
  'column-15': ['text-column-15', 'bg-column-15'],
  'column-16': ['text-column-16', 'bg-column-16']
} as const

export const textColors = {
  primary: ['text-primary', 'bg-primary'],
  secondary: ['text-secondary', 'bg-secondary'],
  placeholder: ['text-placeholder', 'bg-placeholder'],
  disabled: ['text-disabled', 'bg-disabled'],
  'disabled-new': ['text-disabled-new', 'bg-disabled-new'],
  invert: ['text-invert', 'bg-invert'],
  invert22: ['text-invert22', 'bg-invert22']
} as const

export const iconStickerColors = {
  'icon-sticker-panel': ['text-icon-sticker-panel', 'bg-icon-sticker-panel'],
  'icon-sticker-white': ['text-icon-sticker-white', 'bg-icon-sticker-white'],
  'icon-sticker-gray': ['text-icon-sticker-gray', 'bg-icon-sticker-gray'],
  'icon-sticker-red': ['text-icon-sticker-red', 'bg-icon-sticker-red'],
  'icon-sticker-pink': ['text-icon-sticker-pink', 'bg-icon-sticker-pink'],
  'icon-sticker-orange': ['text-icon-sticker-orange', 'bg-icon-sticker-orange'],
  'icon-sticker-green': ['text-icon-sticker-green', 'bg-icon-sticker-green'],
  'icon-sticker-turquoise': [
    'text-icon-sticker-turquoise',
    'bg-icon-sticker-turquoise'
  ],
  'icon-sticker-blue': ['text-icon-sticker-blue', 'bg-icon-sticker-blue'],
  'icon-sticker-violet': ['text-icon-sticker-violet', 'bg-icon-sticker-violet'],
  'icon-sticker-transparent': [
    'text-icon-sticker-transparent',
    'bg-icon-sticker-transparent'
  ]
} as const

export const stickerColors = {
  'sticker-panel': [
    'text-sticker-panel',
    'bg-sticker-panel',
    'outline-sticker-panel'
  ],
  'sticker-white': [
    'text-sticker-white',
    'bg-sticker-white',
    'outline-sticker-white'
  ],
  'sticker-gray': [
    'text-sticker-gray',
    'bg-sticker-gray',
    'outline-sticker-gray'
  ],
  'sticker-red': ['text-sticker-red', 'bg-sticker-red', 'outline-sticker-red'],
  'sticker-pink': [
    'text-sticker-pink',
    'bg-sticker-pink',
    'outline-sticker-pink'
  ],
  'sticker-orange': [
    'text-sticker-orange',
    'bg-sticker-orange',
    'outline-sticker-orange'
  ],
  'sticker-green': [
    'text-sticker-green',
    'bg-sticker-green',
    'outline-sticker-green'
  ],
  'sticker-turquoise': [
    'text-sticker-turquoise',
    'bg-sticker-turquoise',
    'outline-sticker-turquoise'
  ],
  'sticker-blue': [
    'text-sticker-blue',
    'bg-sticker-blue',
    'outline-sticker-blue'
  ],
  'sticker-violet': [
    'text-sticker-violet',
    'bg-sticker-violet',
    'outline-sticker-violet'
  ],
  'sticker-transparent': [
    'text-sticker-transparent',
    'bg-sticker-transparent',
    'outline-sticker-transparent'
  ]
} as const

export const taskColors = {
  'task-primary': ['bg-task-primary', 'border-task-primary'],
  'task-gray': ['bg-task-gray', 'border-task-gray'],
  'task-red': ['bg-task-red', 'border-task-red'],
  'task-pink': ['bg-task-pink', 'border-task-pink'],
  'task-yellow': ['bg-task-yellow', 'border-task-yellow'],
  'task-green': ['bg-task-green', 'border-task-green'],
  'task-turquoise': ['bg-task-turquoise', 'border-task-turquoise'],
  'task-blue': ['bg-task-blue', 'border-task-blue'],
  'task-violet': ['bg-task-violet', 'border-task-violet']
}

export const progressTaskColors = {
  'progress-task-primary': ['bg-progress-task-primary'],
  'progress-task-gray': ['bg-progress-task-gray'],
  'progress-task-red': ['bg-progress-task-red'],
  'progress-task-pink': ['bg-progress-task-pink'],
  'progress-task-yellow': ['bg-progress-task-yellow'],
  'progress-task-green': ['bg-progress-task-green'],
  'progress-task-turquoise': ['bg-progress-task-turquoise'],
  'progress-task-blue': ['bg-progress-task-blue'],
  'progress-task-violet': ['bg-progress-task-violet']
}

export const allColors = {
  ...primaryColors,
  ...customColors,
  ...textColors,
  ...stickerColors,
  ...iconStickerColors,
  ...taskColors,
  ...progressTaskColors
}

export type PrimaryColor = keyof typeof primaryColors
export type CustomColor = keyof typeof customColors
export type TextColor = keyof typeof textColors
export type StickerColor = keyof typeof stickerColors
export type IconStickerColor = keyof typeof iconStickerColors
export type TaskColor = keyof typeof taskColors
export type ProgressTaskColor = keyof typeof progressTaskColors
export type AnyColor = keyof typeof allColors

// TODO: move checking consistency to tools/maintenance script and
// run it in pre-commit (check also consistency with tailwind config)
/**
 * This warns if someone renames color but forgets
 * to rename corresponding tw class.
 */
const checkNamingConsistency = (): void => {
  for (const key of ObjUtil.keys(allColors)) {
    const value = allColors[key] as string[]
    const requiredColors = [`text-${key}`, `bg-${key}`]

    if (!value.some(color => requiredColors.includes(color))) {
      logger.error(`Inconsistent color name for ${key}`)
    }
  }
}
checkNamingConsistency()

export const colorTextClass = (
  color: AnyColor | 'inherit'
): `text-${AnyColor}` | 'text-inherit' => {
  if (color === 'inherit') {
    return 'text-inherit'
  }
  return `text-${color}`
}

export const colorBgClass = (color: AnyColor): `bg-${AnyColor}` => {
  return `bg-${color}`
}
